import defaultsDeep from 'lodash/defaultsDeep'
import cloneDeep from 'lodash/cloneDeep'
import createTypes from 'constants/createTypes'
import { isHardFail } from 'lib/action'

interface ActionTypeTriplet {
  REQUEST: string
  RECEIVE: string
  FAIL: string
}

interface LocalIdsAction {
  type?: string
  payload?: {
    id?: string
    data?: {
      id?: string
    }
  }
  meta?: {
    previousAction?: {
      payload?: {
        id?: string
      }
    }
  }
  error?: unknown
}

type LocalIdsState = Record<string, boolean>

const createRequestTypes = createTypes.map((a: ActionTypeTriplet) => a.REQUEST)
const createReceiveTypes = createTypes.map((a: ActionTypeTriplet) => a.RECEIVE)
const createFailTypes = createTypes.map((a: ActionTypeTriplet) => a.FAIL)

export default (state: LocalIdsState = {}, action: LocalIdsAction): LocalIdsState => {
  const actionType = action.type ?? ''
  if (createRequestTypes.includes(actionType)) {
    const localId = action.payload?.id
    if (!localId) return state
    return defaultsDeep(
      {
        [localId]: true
      },
      state
    )
  }
  if (createReceiveTypes.includes(actionType)) {
    const receivedId = action.payload?.data?.id
    if (!receivedId) return state
    const updated = cloneDeep(state)
    delete updated[receivedId]
    return updated
  }
  if (createFailTypes.includes(actionType) && isHardFail(action)) {
    const failedId = action.meta?.previousAction?.payload?.id
    if (!failedId) return state
    const updated = cloneDeep(state)
    delete updated[failedId]
    return updated
  }
  return state
}
